import * as requestFromServer from "./EducationTermsCrud";
import { callTypes, educationTermSlice } from "./EducationTermsSlice";

const {actions} = educationTermSlice;

export const getEducationTerms = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getEducationTerms(queryParams)
    .then(response => {
      dispatch(actions.educationTermsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllEducationTerms = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllEducationTerms(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getEducationTerm = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  
  if (!id) {
    return requestFromServer
    .getNewEducationTerm()
    .then(response => {
      dispatch(actions.educationTermFetched(response.data));
    })
    .catch(error => {
      
    });
  }
  
  return requestFromServer
    .getEducationTerm(id)
    .then(response => {
      dispatch(actions.educationTermFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveEducationTerm = branch => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveEducationTerm(branch)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteEducationTerms = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteEducationTerms(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanEducationTermsState = () => dispatch => {
  dispatch(actions.educationTermsStateCleaned());
}